import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class PopoverService {
  private activePopover: any = null;

  setPopover(popover: any) {
    this.activePopover = popover;
  }

  clearPopover() {
       if (this.activePopover) {
      this.activePopover.hide();
      this.activePopover.dispose?.();
      this.activePopover = null;
    }
  }
}
